import { __decorate } from "tslib";
import { Component } from 'decorators';
import view from './paperCard.view.html';
let PaperCardComponent = class PaperCardComponent {
};
PaperCardComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            header: '@',
            description: '@',
        },
        transclude: true,
    })
], PaperCardComponent);
export { PaperCardComponent };
